import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Ex :
 * // component.html
 * {{ 'GMB' | enumTranslate:'platform_key' }}
 * {{ category | enumTranslate:'category' : 'subtext' }}
 */
@Pipe({
    name: 'enumTranslate',
    standalone: true,
})
export class EnumTranslatePipe implements PipeTransform {
    private readonly _translate = inject(TranslateService);

    transform(enumKey: string, enumTranslateKey: string, translateKeySuffix?: string): string {
        if (translateKeySuffix) {
            return this._translate.instant(`enums.${enumTranslateKey}.${enumKey.toLowerCase()}.${translateKeySuffix}`);
        }
        return this._translate.instant(`enums.${enumTranslateKey}.${enumKey.toLowerCase()}`);
    }
}
